/**
 * CRM Stats View Component - Extracted from CRMTab
 * Shows statistics overview for orders
 */
import React from 'react';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../ui/card';
import { Badge } from '../ui/badge';
import { ORDER_STATUSES, STATUS_COLORS } from './crmConstants';

export const CRMStatsView = ({ stats, t }) => {
  if (!stats) return null;

  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
      <Card className="border-l-4 border-l-indigo-500 shadow-md hover:shadow-lg transition-shadow">
        <CardHeader className="pb-2">
          <CardDescription className="text-slate-500">{t.totalOrders}</CardDescription>
          <CardTitle className="text-3xl font-bold text-indigo-600">{stats.total_orders}</CardTitle>
        </CardHeader>
      </Card>
      <Card className="border-l-4 border-l-emerald-500 bg-emerald-50/50 shadow-md hover:shadow-lg transition-shadow">
        <CardHeader className="pb-2">
          <CardDescription className="text-slate-500">{t.totalRevenue}</CardDescription>
          <CardTitle className="text-3xl font-bold text-emerald-600">€{stats.total_pvp?.toLocaleString()}</CardTitle>
        </CardHeader>
      </Card>
      <Card className="border-l-4 border-l-rose-500 bg-rose-50/50 shadow-md hover:shadow-lg transition-shadow">
        <CardHeader className="pb-2">
          <CardDescription className="text-slate-500">{t.totalCost}</CardDescription>
          <CardTitle className="text-3xl font-bold text-rose-600">€{stats.total_pc?.toLocaleString()}</CardTitle>
        </CardHeader>
      </Card>
      <Card className="border-l-4 border-l-sky-500 bg-sky-50/50 shadow-md hover:shadow-lg transition-shadow">
        <CardHeader className="pb-2">
          <CardDescription className="text-slate-500">{t.margin}</CardDescription>
          <CardTitle className="text-3xl font-bold text-sky-600">€{stats.margin?.toLocaleString()}</CardTitle>
        </CardHeader>
      </Card>
      
      {/* Status breakdown */}
      <Card className="col-span-2 md:col-span-4 shadow-md">
        <CardHeader>
          <CardTitle className="text-lg text-slate-700">{t.status}</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="flex flex-wrap gap-2">
            {ORDER_STATUSES.map(status => (
              <Badge key={status} className={STATUS_COLORS[status]}>
                {status}: {stats.status_counts?.[status] || 0}
              </Badge>
            ))}
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default CRMStatsView;
